import React, { useState } from 'react';
import classNames from 'classnames';

import { Column, Row, TableProps } from '../component/types';
import TableView from './TableView';
import ManageColumn from './ManageColumn';
import TableTopView from './TableTopView';
import TableProvider from './provider/Provider';
import TablePagination from './Pagination';

export function Table<T extends Row>({
  children,
  header,
  columns = [],
  rows = [],
  check,
  pagination,
  headerExtension,
  showExtendedDeleteView,
  loadingItemCount = 10,
  loading,
  isBorder,
  isShowTable = true,
  extendedView,
  selectButtonLabel,
  selectButtonProps,
  isShowColumnHeader = true,
  tableType,
  trColor,
  height,
  isStickyHeader,
  isManageColumn,
  download,
  loadingHeight,
  testTableId,
  isFixedColumn,
  isHideYOverflow,
}: TableProps<T>) {
  const [tableColumns, setTableColumns] = useState<Column<T>[]>(columns);
  const [downloadColumns, setDownloadColumns] = useState<Column<T>[]>(
    download?.columns || columns,
  );

  const updateTableColumns = (id: number | string, hide: boolean) => {
    const index = columns.findIndex((item) => item.id === id);
    if (index !== -1) {
      const newColumn = [...columns];
      newColumn[index].hide = !hide;
      setTableColumns(newColumn);
    }

    if (download?.columns) {
      const index = download?.columns?.findIndex((item) => item.id === id);
      if (index !== -1) {
        const newDownloadColumn = [...download.columns];
        newDownloadColumn[index].hide = !hide;
        setDownloadColumns(newDownloadColumn);
      }
    }
  };

  return (
    <TableProvider
      check={check}
      rows={rows}
      columns={columns}
      showExtendedDeleteView={showExtendedDeleteView}
      activePage={pagination?.activePage}
    >
      <div
        data-testid={testTableId}
        className={classNames('border rounded-6 bg-white overflow-hidden', {
          [`border-${tableType}-semi-midlight`]: tableType,
        })}
      >
        <TableTopView
          tableColumns={tableColumns}
          downloadColumns={downloadColumns}
          isManageColumn={isManageColumn}
          check={check}
          headerExtension={headerExtension}
          header={header}
          download={download}
          selectButtonLabel={selectButtonLabel}
          showExtendedDeleteView={showExtendedDeleteView}
          rows={rows}
          selectButtonProps={selectButtonProps}
          columns={columns}
        />

        {isManageColumn ? (
          <ManageColumn<T>
            tableColumns={columns}
            downloadColumns={download?.columns || columns}
            onClickItem={updateTableColumns}
            isDownload={Boolean(download?.columns)}
          />
        ) : null}

        {isShowTable ? (
          <TableView<T>
            height={height}
            isBorder={isBorder}
            tableType={tableType}
            trColor={trColor}
            isStickyHeader={isStickyHeader}
            check={check}
            rows={rows}
            columns={isManageColumn ? tableColumns : columns}
            loading={loading}
            loadingItemCount={loadingItemCount}
            isShowColumnHeader={isShowColumnHeader}
            loadingHeight={loadingHeight}
            activePage={pagination?.activePage || 0}
            isFixedColumn={isFixedColumn}
            isHideYOverflow={isHideYOverflow}
          >
            {children}
          </TableView>
        ) : null}

        {extendedView ? extendedView : null}

        <TablePagination pagination={pagination} rowLength={rows.length} />
      </div>
    </TableProvider>
  );
}

export default Table;
